var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"noviceGuide"},_vm._l((_vm.list),function(item,i){return _c('div',{key:item.key,staticClass:"list-item",on:{"click":function($event){return _vm.goPage(item.key)}}},[_c('span',{staticClass:"text"},[_vm._v(_vm._s(item.key)+"、"+_vm._s(item.title))]),_c('span',{staticClass:"icon"})])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }